import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=3bc55ac0&scoped=true"
import script from "./Configuracion.vue?vue&type=script&lang=js"
export * from "./Configuracion.vue?vue&type=script&lang=js"
import style0 from "./Configuracion.vue?vue&type=style&index=0&id=3bc55ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc55ac0",
  null
  
)

export default component.exports